import React, {FC, ReactElement} from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

//TYPES
export type InfoItemProps = {
  label: string,
  value?: string | number,
  valueSuffix?: string,
  sublabel?: string,
  icon: ReactElement
};

const InfoItem: FC<InfoItemProps> = ({icon, label, value, valueSuffix, sublabel}) => {
  return <Stack>
    <Stack direction="row" sx={{gap: 1, alignItems: 'center'}}>
      {icon}
      <Typography variant="overline" sx={{color: 'text.secondary', m: 0, pt: 0.5, lineHeight: '16px'}}>{label}</Typography>
    </Stack>
    <Typography variant="body1" sx={{pl: 3.5}}>{value} {valueSuffix}</Typography>
    {sublabel && <Typography variant="body1" sx={{pl: 3.5, color: 'grey.500'}}>{sublabel}</Typography>}
  </Stack>;
};
export default InfoItem;